module.exports = __webpack_public_path__ + "static/img/home-new4.f5ea69cd.jpeg";